const EXTERNAL_CLOSE_EVENT = 'predictor-app-close'

export default {
  init() {
    const wcApp = document.querySelector('#app-modal')
    if (wcApp) {
      const modalOpener = document.querySelector('#app-modal-trigger')
      const modalCloser = document.querySelector('#close-app-modal')
      const footballField = document.querySelector('#football-field')

      const closeModal = () => {
        wcApp.classList.remove('is-open')
        setTimeout(() => {
          wcApp.style.display = 'none'
          document.body.style.overflow = ''
          document.documentElement.style.overflow = ''
        }, 200)
      }

      modalOpener.addEventListener('click', (e) => {
        e.preventDefault()
        if (footballField) {
          const rect = footballField.getBoundingClientRect()
          const scrollTop =
            window.scrollY + rect.top - (window.innerHeight - rect.height) / 2
          window.scrollTo({ top: scrollTop })
        }

        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'
        wcApp.style.display = 'block'

        requestAnimationFrame(() =>
          requestAnimationFrame(() => wcApp.classList.add('is-open'))
        )
      })

      // Fallback: close button
      modalCloser.addEventListener('click', closeModal)

      // External event close
      window.addEventListener(EXTERNAL_CLOSE_EVENT, closeModal)
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
